/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsGooglePublicAuthOptions
 */
export interface FxIdDomainSettingsGooglePublicAuthOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdDomainSettingsGooglePublicAuthOptions
     */
    ClientId: string;
}

/**
 * Check if a given object implements the FxIdDomainSettingsGooglePublicAuthOptions interface.
 */
export function instanceOfFxIdDomainSettingsGooglePublicAuthOptions(value: object): value is FxIdDomainSettingsGooglePublicAuthOptions {
    if (!('ClientId' in value) || value['ClientId'] === undefined) return false;
    return true;
}

export function FxIdDomainSettingsGooglePublicAuthOptionsFromJSON(json: any): FxIdDomainSettingsGooglePublicAuthOptions {
    return FxIdDomainSettingsGooglePublicAuthOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsGooglePublicAuthOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsGooglePublicAuthOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'ClientId': json['ClientId'],
    };
}

export function FxIdDomainSettingsGooglePublicAuthOptionsToJSON(json: any): FxIdDomainSettingsGooglePublicAuthOptions {
    return FxIdDomainSettingsGooglePublicAuthOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsGooglePublicAuthOptionsToJSONTyped(value?: FxIdDomainSettingsGooglePublicAuthOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ClientId': value['ClientId'],
    };
}

